export const EMPTY_VALUE = '—';
export const CURRENT_INTEREST = 3.4;
export const MINIMUM_INTEREST = 0.5;
export const MAXIMUM_INTEREST = 15;
